(function () {
  'use strict';

  /* @ngdoc object
   * @name vehicles.view
   * @description
   *
   */
  angular
    .module('events.vehicles.view', [
      'ui.router'
    ]);
}());
